import React, { Component } from "react";
import PropTypes from "prop-types";

import {Graphics} from './components/Graphics';

import "./WaterBath.scss";



export class WaterBath extends Component {

  
  componentWillMount() {
    this.props.createWaterBath({
      props: this.props.defaultProps,
    });
  }

  render() {
    const open = this.props.open ? 'open' : '';
    return (
      <ul>
        <li
          aria-label="Water bath"
          id="WaterBath"
          className={"dropTarget WaterBath " + open}
        >
          {/* <p aria-hidden="true" className="label">{this.props.type}</p> */}
          <Graphics id={this.props.id} />
        </li>
      </ul>
    );
  }
}


WaterBath.propTypes = {
  createWaterBath: PropTypes.func,
  waterBathOpen: PropTypes.func,

};

WaterBath.defaultProps = {};
